export const PUBLIC_BADGE_PATH = 'b';

export function getPublicBadgePath(userBadgeUid: string): string {
  return `${PUBLIC_BADGE_PATH}/${userBadgeUid}`;
}

export function isPublicBadgeUrl(pathname: string): boolean {
  return pathname.startsWith(`/${PUBLIC_BADGE_PATH}/`);
}
